import type { DriftSeverity } from '@/types/rebalance'

const STYLE: Record<DriftSeverity, { cls: string; label: string }> = {
  critical: { cls: 'bg-loss/20 text-loss', label: 'CRITICAL' },
  warning: { cls: 'bg-bernstein/20 text-bernstein', label: 'WARNING' },
  info: { cls: 'bg-ink/10 text-muted', label: 'INFO' },
}

interface DriftBadgeProps {
  severity: DriftSeverity
}

export function DriftBadge({ severity }: DriftBadgeProps) {
  const { cls, label } = STYLE[severity]
  return <span className={`tracked-caps px-2 py-1 text-[10px] ${cls}`}>{label}</span>
}
